import { useState, useEffect } from "react";

interface UseEmailWarningProps {
  currentEmail?: string;
}

export const useEmailWarning = ({ currentEmail }: UseEmailWarningProps) => {
  const [initialEmail, setInitialEmail] = useState<string>("");
  const [showEmailWarning, setShowEmailWarning] = useState(false);

  useEffect(() => {
    // Show warning if email is being edited and is different from initial value (case-insensitive)
    if (
      initialEmail &&
      currentEmail &&
      currentEmail.toLowerCase() !== initialEmail.toLowerCase() &&
      currentEmail.trim() !== ""
    ) {
      setShowEmailWarning(true);
    } else {
      setShowEmailWarning(false);
    }
  }, [currentEmail, initialEmail]);

  return {
    initialEmail,
    setInitialEmail,
    showEmailWarning,
  };
};

export default useEmailWarning;
